import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { DxDataGridModule, DxListModule, DxTreeListModule, DxPopupModule, DxScrollViewModule, DxTextBoxModule, DxTooltipModule, DxLoadPanelModule, DxButtonModule } from 'devextreme-angular';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { NgSelectModule, NG_SELECT_DEFAULT_CONFIG } from '@ng-select/ng-select';
import { ClassifyFormComponent } from './classify-form/classify-form.component';
import { ClassificationComponent } from './classification.component';
import { ClassificationRoutingModule } from './classification-routing.module';
import { ConnectionsService } from '../connections/connections.service';
import { MasterMappingsModule } from '../master-mappings/master-mappings.module';
import { DisableControlDirective } from '../shared/directives/disable-control.directive';
import { SharedModule } from '../shared/shared.module';
import { ClassifyFormService } from './classify-form/classify-form.service';

@NgModule({
  imports: [
    CommonModule,
    ClassificationRoutingModule,
    ReactiveFormsModule,
    NgSelectModule,
    DxDataGridModule,
    DxListModule,
    DxTreeListModule,
    DxPopupModule,
    DxScrollViewModule,
    DxTextBoxModule,
    NgbModule,
    MasterMappingsModule,
    DxLoadPanelModule,
    DxButtonModule
  ],
  declarations: [ClassifyFormComponent, ClassificationComponent],
  providers: [ConnectionsService, ClassifyFormService]
})
export class ClassificationModule { }
